import { h } from 'preact'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SocialIconLink = ({ network, link }) => (
  <a href={link} rel='noopener noreferrer' target='_blank' aria-label={`Connect on ${network}`}><FontAwesomeIcon icon={['fab', network]} /></a>
)

export default SocialIconLink
